import htmx from 'htmx.org'

// Assign htmx to the global window object
window.htmx = htmx
